import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { TitleWithButton } from './utils';
import MembershipInfoCard from 'components/customer/MembershipInfoCard';
import { CUSTOMER_DETAIL_TAB_NAME, ADJUST_TYPES } from 'config/CustomEnums';


const fields = [
  [
    { title: "Total number of coupon acquired", field: 'totalNumberOfCouponsAcquired' },
    { title: "Total number of coupon used", field: 'totalNumberOfCouponsUsed' },
    { title: "Total number of coupon expired", field: 'totalNumberOfCouponsExpired' },
  ],
];

const CouponSection = ({
  customer,
  setActiveTab,
  setAdjustPrompt,
}) => {

  return (
    <>
      <TitleWithButton
        containerExtraClassName="customer-detail-section-title-container"
        title="COUPON"
        titleExtraClassName="customer-detail-section-title"
        firstButtonContent="Adjust"
        firstButtonOnClick={() => {
          // setActiveTab(CUSTOMER_DETAIL_TAB_NAME.coupons);
          setAdjustPrompt({
            show: true,
            adjustType: ADJUST_TYPES.coupon,
          });
        }}
      />


      <MembershipInfoCard
        title=""
        data={customer}
        fields={fields}
      />

    </>
  )
}

const mapPropsToState = (state) => ({
  customer: state.customerList.customer,

});

export default connect(mapPropsToState)(CouponSection);